'use client'
// =========================================================================
// LANDING CLIENT /nexus — refonte au design Aureus Social Pro (vitrine).
// Positionnement : GESTIONNAIRE DE PAIE belge nouvelle génération.
// 8 niveaux (Aureus / la suite / pourquoi / simulateur / optimisation /
// CTA / comment ça se passe / FAQ). Bilingue FR/NL. Capte ?c=NX-014 et
// envoie le lead à /api/nexus-lead. Réutilise les classes .vt-* / .sol-card.
// =========================================================================
import { useState, useEffect } from 'react'
import { NB_CP } from '@/app/lib/nb-cp'
import NexusSplash from '@/app/components/NexusSplash'
import { PRIX_FICHE, PRIX_IMPLEMENTATION } from '@/app/lib/prix-publics';

const PRICE = 29
const GOLD = '#B8913A'

// ── 8 sujets (Niveau 2) — repris du site Aureus Social Pro ──
const SUITE = [
  { ic: '💶', fr: ['Paie & rémunération', `${NB_CP} commissions paritaires, barèmes 2026, primes, ATN, ONSS. Calcul de paie, fiches, pécule et clôture mensuelle automatique le 25.`], nl: ['Loon & verloning', '160 paritaire comités, barema’s 2026, premies, VAA, RSZ. Loonberekening, fiches, vakantiegeld en automatische maandafsluiting op de 25e.'] },
  { ic: '⚖️', fr: ['Commissions paritaires', `Les ${NB_CP} CP à jour : barèmes sectoriels, primes, indexations appliqués automatiquement au bon taux (CP 200, 302, 124, 226…).`], nl: ['Paritaire comités', 'De 160 PC actueel: sectorbarema’s, premies en indexeringen automatisch aan het juiste tarief (PC 200, 302, 124, 226…).'] },
  { ic: '📋', fr: ['Déclarations sociales', 'Dimona IN/OUT en moins de 8 secondes, DmfA XML trimestrielle, Belcotax 281.10/20/30, prêtes et conformes 2026.'], nl: ['Sociale aangiften', 'Dimona IN/OUT in minder dan 8 seconden, DmfA XML per kwartaal, Belcotax 281.10/20/30, klaar en conform 2026.'] },
  { ic: '📄', fr: ['Documents juridiques', 'Contrats, DPA, CGV, NDA, règlement de travail, attestations : générés et signables électroniquement (valeur légale UE).'], nl: ['Juridische documenten', 'Contracten, DPA, AV, NDA, arbeidsreglement, attesten: gegenereerd en elektronisch ondertekenbaar (EU-rechtsgeldig).'] },
  { ic: '🎁', fr: ['Aides & subsides', 'Réductions ONSS, dispenses de précompte, Maribel Social, aides régionales : détectées et calculées pour vous.'], nl: ['Steun & subsidies', 'RSZ-verminderingen, vrijstellingen bedrijfsvoorheffing, Sociale Maribel, regionale steun: gedetecteerd en berekend voor u.'] },
  { ic: '📊', fr: ['Pilotage & analytique', 'Tableau de bord temps réel : masse salariale, ventilation par centre de coût, prévisions et alertes, tout en un écran.'], nl: ['Sturing & analytics', 'Realtime dashboard: loonmassa, verdeling per kostenplaats, prognoses en waarschuwingen, alles op één scherm.'] },
  { ic: '🤖', fr: ['Agents IA 24/7', 'Des agents intelligents qui surveillent vos échéances, vérifient la conformité et répondent à vos questions, jour et nuit.'], nl: ['AI-agents 24/7', 'Slimme agents die uw deadlines bewaken, de conformiteit controleren en uw vragen beantwoorden, dag en nacht.'] },
  { ic: '🔐', fr: ['Conformité & sécurité', 'Chiffrement AES-256, registre RGPD Art. 30, audit trail, hébergement européen. Vos données sociales protégées.'], nl: ['Conformiteit & veiligheid', 'AES-256-versleuteling, GDPR-register Art. 30, audit trail, Europese hosting. Uw sociale gegevens beschermd.'] },
]

const T = {
  navCta: { fr: 'Parler de mon dossier', nl: 'Mijn dossier bespreken' },
  refBy: { fr: 'Recommandé par votre conseiller', nl: 'Aanbevolen door uw adviseur' },
  // Niveau 1
  h1: { fr: 'Votre gestion de paie belge,<br><em>nouvelle génération.</em>', nl: 'Uw Belgisch loonbeheer,<br><em>nieuwe generatie.</em>' },
  heroSub: { fr: 'De la Dimona aux fiches de paie, Aureus Social Pro automatise l’intégralité de vos obligations sociales belges.', nl: 'Van Dimona tot loonfiches: Aureus Social Pro automatiseert al uw Belgische sociale verplichtingen.' },
  cta1: { fr: 'Parler de mon dossier', nl: 'Mijn dossier bespreken' },
  cta2: { fr: 'Voir comment ça se passe', nl: 'Bekijk hoe het werkt' },
  // Niveau 2
  s2ey: { fr: 'La suite complète', nl: 'De complete suite' },
  s2h: { fr: 'Tout votre social, dans un seul outil', nl: 'Uw volledige sociale beheer, in één tool' },
  // Niveau 3
  s3ey: { fr: 'Pourquoi Aureus Social Pro', nl: 'Waarom Aureus Social Pro' },
  s3h: { fr: 'Un outil de pointe, pensé pour vos marges', nl: 'Een geavanceerde tool, ontworpen voor uw marges' },
  w1t: { fr: 'Vos coûts maîtrisés', nl: 'Uw kosten onder controle' },
  w1p: { fr: `${PRIX_FICHE} € par fiche de paie, par mois, après ${PRIX_IMPLEMENTATION} € d’implémentation en une seule fois. Vous savez exactement ce que vous payez chaque mois, sans frais cachés.`, nl: `${PRIX_FICHE} € per loonfiche, per maand, na eenmalig ${PRIX_IMPLEMENTATION} € implementatiekosten. U weet precies wat u elke maand betaalt, zonder verborgen kosten.` },
  w2t: { fr: 'À la hauteur de vos besoins', nl: 'Op maat van uw behoeften' },
  w2p: { fr: 'La hausse des coûts et la pression sur vos marges exigent un outil de pointe : réduction des coûts, digitalisation, automatisation et performance.', nl: 'Stijgende kosten en druk op uw marges vragen een geavanceerde tool: kostenreductie, digitalisering, automatisering en prestatie.' },
  w3t: { fr: 'Digitalisation & automatisation', nl: 'Digitalisering & automatisering' },
  w3p: { fr: 'Vos tâches administratives répétitives disparaissent. Vous vous concentrez sur votre business, sur ce qui vous rapporte de l’argent.', nl: 'Uw repetitieve administratie verdwijnt. U focust op uw business, op wat u geld oplevert.' },
  w4t: { fr: 'L’IA au cœur de votre solution', nl: 'AI in het hart van uw oplossing' },
  w4p: { fr: 'Performance économique, innovation technologique et proximité humaine, réunies dans un seul outil.', nl: 'Economische prestatie, technologische innovatie en menselijke nabijheid, verenigd in één tool.' },
  // Niveau 4
  s4ey: { fr: 'Combien vous allez économiser ?', nl: 'Hoeveel gaat u besparen?' },
  s4h: { fr: 'Estimez vos économies annuelles en 30 secondes', nl: 'Schat uw jaarlijkse besparing in 30 seconden' },
  simEmp: { fr: 'Nombre de travailleurs', nl: 'Aantal werknemers' },
  simCur: { fr: 'Votre coût actuel / mois (€)', nl: 'Uw huidige kost / maand (€)' },
  simAureus: { fr: 'Avec Aureus Social Pro', nl: 'Met Aureus Social Pro' },
  simYou: { fr: 'Vous économisez', nl: 'U bespaart' },
  simYear: { fr: 'par an', nl: 'per jaar' },
  simMonth: { fr: 'par mois', nl: 'per maand' },
  simNote: { fr: 'Estimation sur base d’une fiche par travailleur et par mois. Le prix final dépend du volume réel.', nl: 'Raming op basis van één fiche per werknemer per maand. De uiteindelijke prijs hangt af van het reële volume.' },
  // Niveau 5
  s5ey: { fr: 'Optimisation maximale', nl: 'Maximale optimalisatie' },
  s5h: { fr: 'On va chercher chaque euro pour vous', nl: 'Wij halen elke euro voor u' },
  o1t: { fr: 'Audit de vos obligations sociales', nl: 'Audit van uw sociale verplichtingen' },
  o1p: { fr: 'Un audit offert sur vos 12 derniers mois. Toutes vos fiches de paie analysées au regard de la loi sociale belge : nous vous fournissons les corrections à appliquer.', nl: 'Een gratis audit over uw laatste 12 maanden. Al uw loonfiches getoetst aan het Belgisch sociaal recht: wij bezorgen u de toe te passen correcties.' },
  o2t: { fr: 'Prix fixe, zéro surprise', nl: 'Vaste prijs, nul verrassingen' },
  o2p: { fr: `${PRIX_FICHE} € par fiche de paie, par mois. Aureus Social Pro ne travaille pas avec des prix variables : aucune surprise en fin de mois sur votre facture.`, nl: `${PRIX_FICHE} € per loonfiche, per maand. Aureus Social Pro werkt niet met variabele prijzen: geen verrassingen op uw factuur.` },
  o3t: { fr: 'Audit des primes', nl: 'Premie-audit' },
  o3p: { fr: 'Toutes les primes liées à votre commission paritaire et à votre secteur vous sont transmises en quelques clics. Fini les démarches administratives sans fin.', nl: 'Alle premies gekoppeld aan uw paritair comité en sector, in enkele klikken. Gedaan met eindeloze administratie.' },
  o4t: { fr: 'Les réductions oubliées', nl: 'De vergeten verminderingen' },
  o4p: { fr: 'Des réductions de charges souvent oubliées, détectées pour vous :', nl: 'Vaak vergeten lastenverminderingen, voor u opgespoord:' },
  o4list: { fr: ['Dispense de précompte professionnel', 'Récupération ONSS rétroactive', 'Maribel Social', 'VOP (Flandre)', 'APE / SESAM (Wallonie)', 'Et bien plus encore…'], nl: ['Vrijstelling bedrijfsvoorheffing', 'Retroactieve RSZ-recuperatie', 'Sociale Maribel', 'VOP (Vlaanderen)', 'APE / SESAM (Wallonië)', 'En nog veel meer…'] },
  // Niveau 6
  s6h: { fr: 'Prêt à faire de votre gestion sociale un effet de levier ?', nl: 'Klaar om uw sociaal beheer een hefboom te maken?' },
  // Niveau 7
  s7ey: { fr: 'Comment ça se passe', nl: 'Hoe het werkt' },
  s7h: { fr: 'Opérationnel sans lever le petit doigt', nl: 'Operationeel zonder een vinger uit te steken' },
  steps: {
    fr: [
      ['On démarre', 'On complète le formulaire, vous signez le contrat et vous recevez un e-mail de bienvenue.'],
      ['On collecte', 'Vous nous fournissez les informations nécessaires pour traiter votre audit. On vous remet le résultat et les solutions.'],
      ['Implémentation effective', 'On prépare ensemble l’implémentation de votre société et de vos employés. Vous recevez vos accès employeur et employé.'],
      ['Dernier check avant lancement', 'On ajuste et on modifie pour répondre entièrement aux besoins de votre société.'],
      ['C’est parti !', 'Profitez pleinement de vos économies et d’une administration sociale belge performante.'],
    ],
    nl: [
      ['We starten', 'We vullen het formulier in, u tekent het contract en u ontvangt een welkomstmail.'],
      ['We verzamelen', 'U bezorgt ons de nodige info om uw audit te verwerken. Wij geven u het resultaat en de oplossingen.'],
      ['Effectieve implementatie', 'We bereiden samen de implementatie van uw bedrijf en werknemers voor. U krijgt uw werkgever- en werknemerstoegang.'],
      ['Laatste check voor de start', 'We passen aan tot alles volledig aan de noden van uw bedrijf voldoet.'],
      ['We gaan live!', 'Geniet ten volle van uw besparingen en een performant Belgisch sociaal beheer.'],
    ],
  },
  // Niveau 8
  s8ey: { fr: 'Questions fréquentes', nl: 'Veelgestelde vragen' },
  s8h: { fr: 'Ce qu’on nous demande le plus', nl: 'Wat men ons het vaakst vraagt' },
  faq: {
    fr: [
      ['Combien ça coûte ?', `${PRIX_FICHE} € par fiche de paie, par mois, plus ${PRIX_IMPLEMENTATION} € d’implémentation à l’ouverture du dossier. Ces deux montants sont les seuls : pas de frais cachés.`],
      ['Combien de temps ça me prend ?', 'Très peu : notre équipe installe et paramètre tout. Vous validez, et vous êtes lancé rapidement.'],
      ['Mes données sont-elles en sécurité ?', 'Chiffrement AES-256, hébergement européen conforme RGPD, données sensibles (NISS, IBAN) chiffrées. Jamais revendues.'],
      ['L’audit est-il vraiment gratuit ?', 'Oui. On analyse vos 12 derniers mois de fiches et on vous remet les corrections et économies possibles.'],
      ['Et si je veux arrêter ?', 'Le contrat de services est de 3 ans. Vous récupérez vos données à tout moment.'],
    ],
    nl: [
      ['Hoeveel kost het?', `${PRIX_FICHE} € per loonfiche, plus eenmalig ${PRIX_IMPLEMENTATION} € implementatiekosten bij de opening van het dossier. Dat zijn de enige twee bedragen: geen verborgen kosten. Het dienstencontract loopt drie jaar.`],
      ['Hoeveel tijd kost het mij?', 'Heel weinig: ons team installeert en configureert alles. U valideert en bent snel live.'],
      ['Zijn mijn gegevens veilig?', 'AES-256-versleuteling, Europese GDPR-conforme hosting, gevoelige gegevens (INSZ, IBAN) versleuteld. Nooit doorverkocht.'],
      ['Is de audit echt gratis?', 'Ja. We analyseren uw laatste 12 maanden en bezorgen u de correcties en mogelijke besparingen. U betaalt niets voor die analyse.'],
      ['En als ik wil stoppen?', 'Het dienstencontract heeft een initiële duur van drie jaar, met een opzegtermijn van 3 maanden vóór de vervaldag. Uw gegevens blijven hoe dan ook van u en zijn op elk moment exporteerbaar.'],
    ],
  },
  // Form
  fEy: { fr: '45 minutes', nl: '45 minuten' },
  fH: { fr: 'Parlons de votre dossier', nl: 'Laten we uw dossier bespreken' },
  fLead: { fr: 'On regarde votre situation réelle et on vous montre ce que ça change, et ce que ça coûte.', nl: 'We bekijken uw reële situatie en tonen u wat het verandert, en wat het kost.' },
  phName: { fr: 'Votre nom', nl: 'Uw naam' }, phEmail: { fr: 'Email professionnel', nl: 'Professioneel e-mailadres' },
  phCo: { fr: 'Société', nl: 'Onderneming' }, phTel: { fr: 'Téléphone *', nl: 'Telefoon *' },
  fBtn: { fr: 'Parler de mon dossier', nl: 'Mijn dossier bespreken' }, fBtnLoad: { fr: 'Envoi…', nl: 'Verzenden…' },
  fErr: { fr: 'Votre nom, votre e-mail et votre téléphone sont requis.', nl: 'Uw naam, e-mailadres en telefoonnummer zijn vereist.' },
  sentH: { fr: 'Demande reçue !', nl: 'Aanvraag ontvangen!' },
  ft: { fr: 'Aureus Social Pro. Gestionnaire de paie belge nouvelle génération.', nl: 'Aureus Social Pro. Belgisch loonbeheer, nieuwe generatie.' },
}

const CSS = `
.nxv{font-family:'Cabinet Grotesk',sans-serif;background:#fff;color:#0E0D0A;-webkit-font-smoothing:antialiased;overflow-x:hidden;min-height:100vh}
.nxv h1,.nxv h2,.nxv h3,.nxv h4{font-family:'Fraunces',serif;font-weight:400;line-height:1.08;letter-spacing:-.02em;margin:0}
.nxv h1{font-size:clamp(30px,5.5vw,64px)}.nxv h2{font-size:clamp(26px,3.8vw,46px)}.nxv h3{font-size:clamp(19px,2.2vw,26px)}
.nxv h1 em,.nxv em{font-style:italic;color:${GOLD}}
.nxv p{font-size:16px;line-height:1.75;color:#56524A;font-weight:300;margin:0}
.nxv .wrap{max-width:1160px;margin:0 auto;padding:0 28px}
.nxv .sec{padding:80px 0;border-top:1px solid #F1EDE6}
@media(max-width:768px){.nxv .sec{padding:48px 0}.nxv .wrap{padding:0 18px}}
.nxv .ey{display:inline-flex;align-items:center;gap:8px;font-size:11px;font-weight:700;color:${GOLD};letter-spacing:.14em;text-transform:uppercase;margin-bottom:14px;font-family:'Cabinet Grotesk',sans-serif}
.nxv .ey::before{content:'';width:18px;height:2px;background:${GOLD};border-radius:1px}
.nxv .bar{position:sticky;top:0;z-index:40;background:rgba(255,255,255,.9);backdrop-filter:blur(10px);border-bottom:1px solid #F1EDE6}
.nxv .bar-in{max-width:1160px;margin:0 auto;padding:0 28px;height:64px;display:flex;align-items:center;gap:12px}
.nxv .logo{width:34px;height:34px;border-radius:9px;display:grid;place-items:center;font-weight:800;font-size:15px;background:linear-gradient(140deg,#D4A84C,${GOLD});color:#1a1408;font-family:'Cabinet Grotesk',sans-serif}
.nxv .brand{font-weight:700;font-size:15px;letter-spacing:-.01em}
.nxv .bar .right{margin-left:auto;display:flex;align-items:center;gap:10px}
.nxv .lang{display:flex;border:1px solid #E8E4DC;border-radius:8px;overflow:hidden}
.nxv .lang button{font:inherit;font-family:'Fira Code',monospace;font-size:12px;font-weight:600;background:none;border:0;color:#9A968E;padding:6px 11px;cursor:pointer}
.nxv .lang button[aria-pressed="true"]{background:${GOLD};color:#fff}
.nxv .btn-gold{display:inline-flex;align-items:center;gap:8px;padding:13px 26px;border-radius:6px;background:linear-gradient(135deg,${GOLD},#D4A84C);color:#1a1408;font-size:14px;font-weight:700;border:none;cursor:pointer;text-decoration:none;transition:.2s;box-shadow:0 4px 22px rgba(184,145,58,.35);font-family:'Cabinet Grotesk',sans-serif}
.nxv .btn-gold:hover{transform:translateY(-2px);box-shadow:0 8px 30px rgba(184,145,58,.45)}
.nxv .btn-dark{display:inline-flex;align-items:center;gap:8px;padding:13px 26px;border-radius:6px;background:#0E0D0A;color:#fff;font-size:14px;font-weight:600;border:0;cursor:pointer;text-decoration:none;transition:.2s;font-family:'Cabinet Grotesk',sans-serif}
.nxv .btn-dark:hover{background:#252320}
.nxv .btn-s{display:inline-flex;align-items:center;gap:8px;padding:13px 24px;border-radius:6px;background:transparent;color:#0E0D0A;font-size:14px;font-weight:500;border:1.5px solid #E8E4DC;cursor:pointer;text-decoration:none;transition:.2s;font-family:'Cabinet Grotesk',sans-serif}
.nxv .btn-s:hover{border-color:#0E0D0A;background:#F9F6F0}
.nxv .bar .btn-gold{padding:9px 16px;font-size:13px}
.nxv .hero{padding:76px 0 20px;position:relative}
.nxv .hero .ref{display:inline-block;background:#FBF3E2;border:1px solid #D4B870;border-radius:99px;padding:6px 15px;font-size:12.5px;color:#6A4E10;margin-bottom:22px}
.nxv .hero .ref b{color:${GOLD}}
.nxv .hero h1{max-width:16ch}
.nxv .hero p{font-size:clamp(16px,2vw,20px);max-width:56ch;margin-top:22px}
.nxv .hero .cta{margin-top:32px;display:flex;gap:12px;flex-wrap:wrap}
.nxv .trust{display:flex;gap:22px;flex-wrap:wrap;margin-top:30px;font-size:13px;color:#9A968E}
.nxv .trust b{color:#1A5C42}
.nxv .sol-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:16px;margin-top:38px}
@media(max-width:900px){.nxv .sol-grid{grid-template-columns:1fr 1fr}}@media(max-width:520px){.nxv .sol-grid{grid-template-columns:1fr}}
.nxv .sol{background:#fff;border:1px solid #E8E4DC;border-radius:16px;padding:24px;transition:.28s;display:flex;flex-direction:column;gap:12px;position:relative;overflow:hidden}
.nxv .sol::after{content:'';position:absolute;bottom:0;left:0;right:0;height:3px;background:linear-gradient(90deg,${GOLD},transparent);transform:scaleX(0);transform-origin:left;transition:transform .3s}
.nxv .sol:hover{box-shadow:0 8px 36px rgba(14,13,10,.1);transform:translateY(-4px)}.nxv .sol:hover::after{transform:scaleX(1)}
.nxv .sol .ico{width:46px;height:46px;border-radius:11px;background:#F1EDE6;border:1px solid #E8E4DC;display:grid;place-items:center;font-size:22px}
.nxv .sol h4{font-family:'Cabinet Grotesk',sans-serif;font-size:16px;font-weight:700;color:#0E0D0A;line-height:1.3}
.nxv .sol p{font-size:13.5px;line-height:1.65}
.nxv .why{display:grid;grid-template-columns:repeat(2,1fr);gap:20px;margin-top:36px}
@media(max-width:720px){.nxv .why{grid-template-columns:1fr}}
.nxv .why .c{background:#F9F6F0;border:1px solid #F1EDE6;border-radius:16px;padding:28px}
.nxv .why .c h3{margin-bottom:10px}
.nxv .why .c.big{background:#0E0D0A}.nxv .why .c.big h3{color:#fff}.nxv .why .c.big p{color:rgba(255,255,255,.72)}
.nxv .sim{background:#0E0D0A;border-radius:20px;padding:38px;margin-top:36px;color:#fff}
@media(max-width:720px){.nxv .sim{padding:24px}}
.nxv .sim .row{display:grid;grid-template-columns:1fr 1fr;gap:22px}
@media(max-width:640px){.nxv .sim .row{grid-template-columns:1fr}}
.nxv .sim label{font-size:12px;color:rgba(255,255,255,.55);text-transform:uppercase;letter-spacing:.05em;font-weight:600;font-family:'Fira Code',monospace}
.nxv .sim .val{font-family:'Fraunces',serif;font-size:30px;margin:6px 0 12px}
.nxv .sim input[type=range]{width:100%;accent-color:${GOLD};height:5px}
.nxv .sim input[type=number]{width:100%;box-sizing:border-box;background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.15);border-radius:8px;padding:11px 13px;color:#fff;font-size:16px;font-family:'Cabinet Grotesk',sans-serif;outline:none;margin-top:6px}
.nxv .sim .out{display:grid;grid-template-columns:1fr 1fr;gap:1px;background:rgba(255,255,255,.1);border-radius:12px;overflow:hidden;margin-top:26px}
.nxv .sim .out .cell{background:#141310;padding:20px}
.nxv .sim .out .cap{font-size:12px;color:rgba(255,255,255,.5);font-family:'Fira Code',monospace}
.nxv .sim .out .big{font-family:'Fraunces',serif;font-size:clamp(26px,4vw,40px);margin-top:6px}
.nxv .sim .out .save .big{color:#3ecf8e}.nxv .sim .out .aur .big{color:#D4A84C}
.nxv .sim .note{font-size:12px;color:rgba(255,255,255,.4);margin-top:16px}
.nxv .opt{display:grid;grid-template-columns:repeat(2,1fr);gap:18px;margin-top:36px}
@media(max-width:720px){.nxv .opt{grid-template-columns:1fr}}
.nxv .opt .c{border:1px solid #E8E4DC;border-radius:16px;padding:28px}
.nxv .opt .c h3{margin-bottom:10px}
.nxv .opt ul{margin:14px 0 0;padding:0;list-style:none;display:grid;gap:9px}
.nxv .opt li{padding-left:26px;position:relative;font-size:14.5px;color:#56524A}
.nxv .opt li::before{content:'✓';position:absolute;left:0;color:#1A5C42;font-weight:800}
.nxv .cta-band{background:linear-gradient(135deg,#0E0D0A,#252320);border-radius:24px;padding:64px 32px;text-align:center;margin-top:12px}
.nxv .cta-band h2{color:#fff;max-width:20ch;margin:0 auto}
.nxv .cta-band .cta{margin-top:28px;display:flex;gap:12px;justify-content:center;flex-wrap:wrap}
.nxv .steps{display:grid;grid-template-columns:repeat(5,1fr);gap:14px;margin-top:38px}
@media(max-width:900px){.nxv .steps{grid-template-columns:1fr 1fr}}@media(max-width:520px){.nxv .steps{grid-template-columns:1fr}}
.nxv .step{background:#F9F6F0;border:1px solid #F1EDE6;border-radius:14px;padding:22px}
.nxv .step .n{width:34px;height:34px;border-radius:9px;background:${GOLD};color:#fff;display:grid;place-items:center;font-family:'Fraunces',serif;font-size:17px;margin-bottom:12px}
.nxv .step h4{font-family:'Cabinet Grotesk',sans-serif;font-size:15px;font-weight:700;margin-bottom:6px}
.nxv .step p{font-size:13px}
.nxv .faq{max-width:800px;margin:34px auto 0;display:flex;flex-direction:column;gap:10px}
.nxv details{background:#fff;border:1px solid #E8E4DC;border-radius:12px;padding:2px 20px}
.nxv summary{cursor:pointer;list-style:none;padding:16px 0;font-weight:600;font-size:15.5px;display:flex;align-items:center;gap:12px;font-family:'Cabinet Grotesk',sans-serif}
.nxv summary::-webkit-details-marker{display:none}
.nxv summary .cv{margin-left:auto;color:${GOLD};transition:.2s}.nxv details[open] summary .cv{transform:rotate(45deg)}
.nxv details p{padding:0 0 18px;font-size:14.5px}
.nxv .form-card{background:#F9F6F0;border:1px solid #F1EDE6;border-radius:22px;padding:44px 32px;max-width:620px;margin:36px auto 0;text-align:center}
.nxv .form{display:grid;gap:11px;max-width:440px;margin:22px auto 0;text-align:left}
.nxv .form .two{display:grid;grid-template-columns:1fr 1fr;gap:11px}
@media(max-width:480px){.nxv .form .two{grid-template-columns:1fr}}
.nxv .form input{background:#fff;border:1px solid #E8E4DC;border-radius:9px;padding:13px 15px;font-size:14px;outline:none;width:100%;box-sizing:border-box;font-family:'Cabinet Grotesk',sans-serif;color:#0E0D0A}
.nxv .form input:focus{border-color:${GOLD}}
.nxv footer{border-top:1px solid #F1EDE6;padding:34px 0;text-align:center;font-size:12.5px;color:#9A968E}
`

export default function NexusLanding() {
  const [lang, setLang] = useState('fr')
  const [code, setCode] = useState('')
  const [conseiller, setConseiller] = useState('')
  const [workers, setWorkers] = useState(8)
  const [current, setCurrent] = useState('')
  const [form, setForm] = useState({ name: '', email: '', company: '', phone: '' })
  const [sent, setSent] = useState(false)
  const [loading, setLoading] = useState(false)
  const [err, setErr] = useState(null)

  useEffect(() => {
    try {
      const p = new URLSearchParams(window.location.search)
      const c = p.get('c') || p.get('code') || ''
      setCode(c); if (c) setConseiller(c)
      const l = (p.get('lang') || '').toLowerCase()
      if (l === 'nl' || l === 'fr') setLang(l)
      else if ((navigator.language || '').toLowerCase().startsWith('nl')) setLang('nl')
    } catch {}
  }, [])

  const t = (k) => (T[k] ? T[k][lang] : k)
  const h = (k) => ({ __html: T[k] ? T[k][lang] : k })
  const fmt = (n) => Math.round(n).toLocaleString(lang === 'nl' ? 'nl-BE' : 'fr-BE')
  const aureusMonth = workers * PRICE
  const cur = parseFloat(String(current).replace(',', '.')) || 0
  const saveMonth = cur > 0 ? Math.max(0, cur - aureusMonth) : 0

  const submit = async () => {
    // ⚠️ Deux corrections le 13/08/2026. La condition était en ET : elle ne
    // bloquait que si les TROIS champs étaient vides, donc un nom seul suffisait
    // à envoyer un lead sans e-mail ni téléphone. Et le téléphone devient requis.
    if (!form.name || !form.email || !form.phone) { setErr(t('fErr')); return }
    setLoading(true); setErr(null)
    try {
      await fetch('/api/nexus-lead', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ...form, workers, code }) })
      setSent(true)
    } catch { setSent(true) }
    setLoading(false)
  }

  return (
    <div className="nxv" lang={lang}>
      <NexusSplash />
      <style>{CSS}</style>

      <header className="bar"><div className="bar-in">
        <div className="logo">A</div><span className="brand">Aureus Social Pro</span>
        <div className="right">
          <div className="lang" role="group" aria-label="Langue / Taal">
            <button aria-pressed={lang === 'fr'} onClick={() => setLang('fr')}>FR</button>
            <button aria-pressed={lang === 'nl'} onClick={() => setLang('nl')}>NL</button>
          </div>
          <a href="#demo" className="btn-gold">{t('navCta')}</a>
        </div>
      </div></header>

      {/* NIVEAU 1 — HERO */}
      <section className="hero"><div className="wrap">
        {conseiller && <div className="ref" dangerouslySetInnerHTML={{ __html: `${t('refBy')} <b>${conseiller}</b>` }} />}
        <h1 dangerouslySetInnerHTML={h('h1')} />
        <p dangerouslySetInnerHTML={h('heroSub')} />
        <div className="cta">
          <a href="#demo" className="btn-gold">{t('cta1')} →</a>
          <a href="#etapes" className="btn-s">{t('cta2')}</a>
        </div>
        <div className="trust">
          <span><b>✓</b> 100 % belge</span><span><b>✓</b> ${NB_CP} CP à jour</span>
          <span><b>✓</b> RGPD · AES-256</span><span><b>✓</b> Devis gratuit</span>
        </div>
      </div></section>

      {/* NIVEAU 2 — LA SUITE COMPLÈTE */}
      <section className="sec"><div className="wrap">
        <div className="ey">{t('s2ey')}</div>
        <h2>{t('s2h')}</h2>
        <div className="sol-grid">
          {SUITE.map((s, i) => (
            <div className="sol" key={i}>
              <div className="ico">{s.ic}</div>
              <h4>{s[lang][0]}</h4>
              <p>{s[lang][1]}</p>
            </div>
          ))}
        </div>
      </div></section>

      {/* NIVEAU 3 — POURQUOI */}
      <section className="sec"><div className="wrap">
        <div className="ey">{t('s3ey')}</div>
        <h2>{t('s3h')}</h2>
        <div className="why">
          <div className="c big"><h3>{t('w1t')}</h3><p>{t('w1p')}</p></div>
          <div className="c"><h3>{t('w2t')}</h3><p>{t('w2p')}</p></div>
          <div className="c"><h3>{t('w3t')}</h3><p>{t('w3p')}</p></div>
          <div className="c"><h3>{t('w4t')}</h3><p>{t('w4p')}</p></div>
        </div>
      </div></section>

      {/* NIVEAU 4 — SIMULATEUR */}
      <section className="sec"><div className="wrap">
        <div className="ey">{t('s4ey')}</div>
        <h2>{t('s4h')}</h2>
        <div className="sim">
          <div className="row">
            <div>
              <label>{t('simEmp')}</label>
              <div className="val">{workers}</div>
              <input type="range" min="1" max="80" value={workers} onChange={e => setWorkers(+e.target.value)} aria-label={t('simEmp')} />
            </div>
            <div>
              <label>{t('simCur')}</label>
              <input type="number" min="0" placeholder="—" value={current} onChange={e => setCurrent(e.target.value)} />
            </div>
          </div>
          <div className="out">
            <div className="cell aur"><div className="cap">{t('simAureus')}</div><div className="big">{fmt(aureusMonth)} € <span style={{ fontSize: 14, color: 'rgba(255,255,255,.5)' }}>/ {t('simMonth')}</span></div></div>
            <div className="cell save"><div className="cap">{t('simYou')}</div><div className="big">{cur > 0 ? `${fmt(saveMonth * 12)} €` : '—'} <span style={{ fontSize: 14, color: 'rgba(255,255,255,.5)' }}>/ {t('simYear')}</span></div></div>
          </div>
          <div className="note">{t('simNote')}</div>
        </div>
      </div></section>

      {/* NIVEAU 5 — OPTIMISATION */}
      <section className="sec"><div className="wrap">
        <div className="ey">{t('s5ey')}</div>
        <h2>{t('s5h')}</h2>
        <div className="opt">
          <div className="c"><h3>{t('o1t')}</h3><p>{t('o1p')}</p></div>
          <div className="c"><h3>{t('o2t')}</h3><p>{t('o2p')}</p></div>
          <div className="c"><h3>{t('o3t')}</h3><p>{t('o3p')}</p></div>
          <div className="c"><h3>{t('o4t')}</h3><p>{t('o4p')}</p>
            <ul>{t('o4list').map((x, i) => <li key={i}>{x}</li>)}</ul>
          </div>
        </div>
      </div></section>

      {/* NIVEAU 6 — BANDEAU CTA */}
      <section className="sec"><div className="wrap">
        <div className="cta-band">
          <h2>{t('s6h')}</h2>
          <div className="cta">
            <a href="#etapes" className="btn-s" style={{ color: '#fff', borderColor: 'rgba(255,255,255,.3)' }}>{t('cta2')}</a>
            <a href="#demo" className="btn-gold">{t('cta1')} →</a>
          </div>
        </div>
      </div></section>

      {/* NIVEAU 7 — COMMENT ÇA SE PASSE */}
      <section id="etapes" className="sec"><div className="wrap">
        <div className="ey">{t('s7ey')}</div>
        <h2>{t('s7h')}</h2>
        <div className="steps">
          {t('steps').map((s, i) => (
            <div className="step" key={i}><div className="n">{i + 1}</div><h4>{s[0]}</h4><p>{s[1]}</p></div>
          ))}
        </div>
      </div></section>

      {/* NIVEAU 8 — FAQ */}
      <section className="sec"><div className="wrap">
        <div className="ey">{t('s8ey')}</div>
        <h2>{t('s8h')}</h2>
        <div className="faq">
          {t('faq').map((f, i) => (
            <details key={i} open={i === 0}><summary>{f[0]}<span className="cv">＋</span></summary><p>{f[1]}</p></details>
          ))}
        </div>
      </div></section>

      {/* DÉMO */}
      <section id="demo" className="sec"><div className="wrap">
        <div className="form-card">
          {sent ? (
            <div>
              <div style={{ fontSize: 46, marginBottom: 8 }}>✅</div>
              <h2 style={{ color: GOLD }}>{t('sentH')}</h2>
              <p style={{ marginTop: 8 }}>{lang === 'nl' ? `We contacteren u binnen 24 u${conseiller ? `. Uw adviseur ${conseiller} is op de hoogte.` : '.'}` : `On vous recontacte sous 24 h${conseiller ? `. Votre conseiller ${conseiller} est informé.` : '.'}`}</p>
            </div>
          ) : (
            <div>
              <div className="ey" style={{ justifyContent: 'center' }}>{t('fEy')}</div>
              <h2>{t('fH')}</h2>
              <p style={{ marginTop: 10 }}>{t('fLead')}</p>
              <div className="form">
                <div className="two">
                  <input placeholder={t('phName')} value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} />
                  <input placeholder={t('phEmail')} value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} />
                </div>
                <div className="two">
                  <input placeholder={t('phCo')} value={form.company} onChange={e => setForm(f => ({ ...f, company: e.target.value }))} />
                  <input placeholder={t('phTel')} value={form.phone} onChange={e => setForm(f => ({ ...f, phone: e.target.value }))} />
                </div>
                {err && <div style={{ fontSize: 13, color: '#C0392B' }}>{err}</div>}
                <button onClick={submit} disabled={loading} className="btn-gold" style={{ justifyContent: 'center', padding: 14 }}>{loading ? t('fBtnLoad') : t('fBtn') + ' →'}</button>
              </div>
            </div>
          )}
        </div>
      </div></section>

      <footer><div className="wrap">{t('ft')}{conseiller ? ` · ${conseiller}` : ''}</div></footer>
    </div>
  )
}
